import * as React from "react";
import MuiFade from "@material-ui/core/Fade";

export type FadeProps = {
  visible: boolean;
  // Fade in on first mount too, not only when `visible` changes; on by default, as MUI's Fade.
  appear?: boolean;
  durationMs?: number;
  // One element that can hold a ref, e.g. a div: the fade sets its opacity directly.
  children: React.ReactElement;
};

export const Fade: React.FC<FadeProps> = ({ visible, appear = true, durationMs, children }) => (
  <MuiFade in={visible} appear={appear} timeout={durationMs}>
    {children}
  </MuiFade>
);
